import React, { useEffect, useState } from "react";
import { alertError, alertSuccess } from "Utils/alerts";
import { t } from "i18next";
import useFormState from "Utils/useFormState";
import QboxmailApi from "@/qboxmailApi";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import Checkbox from "Components/checkbox/Checkbox";
import WarningBanner from "Components/warningBanner/WarningBanner";
import ConfirmModal from "Components/confirmModal/ConfirmModal";
import ResponsiveButtonGroup from "Components/responsiveButtonGroup/ResponsiveButtonGroup";
import RadioButton from "Components/radiobutton/RadioButton";
import cx from "classnames";
import s from "../../delivery.scss";

const api = new QboxmailApi({ useCookie: true });

const VolumeManagement = ({ accountData, onDetailsUpdated }) => {
  const {
    setFormFieldValue,
    formData,
    formErrors,
    setFormLoading,
    unsetFormLoading,
    isFormLoading,
    hasFormChanged,
    setInitialValues,
    resetToInitialState,
    setFormErrors,
  } = useFormState({});

  useEffect(() => {
    setInitialValues({
      num_messages: accountData.num_messages,
      override_plan_num_messages: !accountData.reset_to_plan_num_messages,
      next_renewal_action: accountData.reset_to_plan_num_messages ? "restore" : "maintain",
    });
  }, [accountData, setInitialValues]);

  const validateForm = () => {
    if (!formData.num_messages || formData.num_messages < 0) {
      setFormErrors({ num_messages: t("errorMsg.missing.field") });
      return false;
    }

    return true;
  };

  const submitAccountInfo = async () => {
    setFormLoading();

    if (!validateForm()) {
      unsetFormLoading();
      return;
    }

    try {
      await api.updateDeliveryAccountInfo({
        id: accountData.id,
        ...formData,
      });
      // await onDetailsUpdated();
      alertSuccess(t("alert.deliveryAccount.updated"));
      setFormErrors({});
    } catch (error) {
      console.log(error);
    }
    unsetFormLoading();
  };

  return (
    <div className={cx(s.dashboardContainer, s.noMarginTop)}>
      <div className={s.dashboardHeader}>
        <ResponsiveButtonGroup
          buttonElements={[
            hasFormChanged ? (
              <Button onClick={resetToInitialState} color="outline" key={0}>
                button.cancel
              </Button>
            ) : null,
            <Button loading={isFormLoading} onClick={submitAccountInfo} key={1}>
              button.save
            </Button>,
          ]}
          warningElement={hasFormChanged && <WarningBanner color="yellow-text" msg={t("infoMsg.unsaveChanged")} />}
          className="flex items-center justify-end expand gap20"
        />
      </div>
      <div className={s.dashboardContent}>
        <div className={s.dashboardItem1}>
          <div className="settingTitle">{t("delivery.accounts.volumeManagement.title")}</div>
          <div className="sectionDesc">{t("delivery.accounts.volumeManagement.desc")}</div>
        </div>
        <div className={s.dashboardItem2}>
          <Input
            name="num_messages"
            type="number"
            min={0}
            step={100}
            hint={`Il valore previsto dal piano è ${accountData.plan_num_messages}`}
            label={t("input.label.volume")}
            placeholder={t("input.label.volume")}
            errors={formErrors.num_messages}
            onChange={setFormFieldValue}
            value={formData.num_messages}
          />

          {/* <Checkbox
            className="inputFull2"
            label={t("input.label.override_plan_num_messages")}
            name="override_plan_num_messages"
            checked={formData.override_plan_num_messages}
            onChange={setFormFieldValue}
          /> */}

          {(accountData.plan === "free" || accountData.plan === "monthly") && (
            <RadioButton
              className="mt-6 inputFull2"
              grouplabel="Cosa fare al prossimo rinnovo"
              //eslint-disable-next-line
              children={[
                {
                  value: "restore",
                  label: t("input.label.restore_plan_num_messages", {
                    value: accountData.plan_num_messages,
                  }),
                },
                {
                  value: "maintain",
                  label: t("input.label.override_plan_num_messages", {
                    value: formData.num_messages,
                  }),
                },
              ]}
              name="next_renewal_action"
              value={formData.next_renewal_action}
              onChange={(e) => {
                if (e.next_renewal_action === "restore") {
                  setFormFieldValue({ override_plan_num_messages: false, ...e });
                } else {
                  setFormFieldValue({ override_plan_num_messages: true, ...e });
                }
              }}
            />
          )}
        </div>
      </div>

      {/* <ConfirmModal
        opened={isPasswordModalOpen}
        title={t("delivery.accounts.detailsAndSecurity.newPassword.modal.title")}
        text={"delivery.accounts.detailsAndSecurity.newPassword.modal.desc"}
        textButton="button.generate.password"
        isWarning
        translate
        handleClose={() => setIsPasswordModalOpen(false)}
        action={generateNewPassword}
        isLoading={isFormLoading}
      /> */}
    </div>
  );
};

export default VolumeManagement;
